export default __webpack_public_path__ + "static/media/blue0.a4f18542.gif";